module.exports = __webpack_public_path__ + "media/images/icon/play-0455d228e46bdb6ce5344396012dd011.svg";